export const endpoints = {
  get: '/centralRefused',
  delete: '/centralRefused/:centralId',
  enableCentral: '/centralRefused/enableCentral',
}
